import React from 'react';

const LineIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="86" viewBox="0 0 8 86" fill="none" {...rest}>
      <path d="M4 0.333333C2.52724 0.333333 1.33333 1.52724 1.33333 3C1.33333 4.47276 2.52724 5.66667 4 5.66667C5.47276 5.66667 6.66667 4.47276 6.66667 3C6.66667 1.52724 5.47276 0.333333 4 0.333333ZM3.64644 85.3536C3.84171 85.5488 4.15829 85.5488 4.35355 85.3536L7.53553 82.1716C7.73079 81.9763 7.73079 81.6597 7.53553 81.4645C7.34027 81.2692 7.02369 81.2692 6.82842 81.4645L4 84.2929L1.17157 81.4645C0.976307 81.2692 0.659725 81.2692 0.464463 81.4645C0.2692 81.6597 0.2692 81.9763 0.464463 82.1716L3.64644 85.3536ZM3.5 3L3.5 85L4.5 85L4.5 3L3.5 3Z" fill="#2857FC" {...rest} />
    </svg>
  );
};

export default LineIcon;